module.exports = __webpack_public_path__ + "static/media/react.8ab07802.jpg";